import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import "./styles/NotFound.css";
import { AppRoutes } from "../common/app-routes";
import SEO from "./SEO";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="404 Not Found – Page Doesn’t Exist"
        description="You’ve reached an unknown route in the app. Click to return to the homepage and get back on track."
      />
      <div className="notfound-container">
        <img src={"./confused-panda-transparent.png"} alt="Confused Panda" className="notfound-image" />
        <h1 className="notfound-title">Seems like you got here by mistake 🐼</h1>
        <p className="notfound-message">But no worries! Let’s get you back to safety.</p>
        <Button onClick={() => navigate(AppRoutes.HOME)}>Go Home</Button>
      </div>
    </>
  );
};

export default NotFound;
